import React from 'react';
import { connect } from 'react-redux';

import RsvpToPerformActionLink from "../common/components/rsvp-to-perform-action-link";
import RsvpToPerformActionButton from "../common/components/rsvp-to-perform-action-button";
import * as actions from "./actions";
import * as utils from "../utils";
import store from "../store";


class SponsoredRegistry extends React.Component {

  constructor(props) {
    super(props);

    this.mounted = false;
    // about this... see note in handleStateChange(), below
    this.subscribedToStateChanges = false;
  }

  render() {
    if (!shouldShowSponsoredRegistry()) {
      return null;
    }

    const isMobile = utils.isMobile();
    const topClassNames = `sponsored-registry ${window.sponsored_registry_name} simple-shadowbox${isMobile ? " mobile" : ""}`;
    const headlineText = window.sponsored_registry_data.component_headline;
    const subHeadingText = window.sponsored_registry_data.component_sub_heading;
    const iconImgClasses = `sponsored_registry_icon ${window.sponsored_registry_name}`;
    const imgRootPath = `/assets/images/sponsored_registry/${window.sponsored_registry_name}/`;
    const iconImgUrl = imgRootPath + window.sponsored_registry_data.icon_image;
    const heroImgUrl = imgRootPath + window.sponsored_registry_data.hero_image;

    this.state = this.getStateFromStore();
    let viewComponent = <SponsoredRegistrySelect sponsoredRegistry={ this.state } />;

    this.subscribeToStateChangesIfNeeded();

    return (
      <div className={topClassNames} id="sponsored-registry">
        <div className="sponsored-registry-icon">
          <img className={iconImgClasses} src={iconImgUrl} />
        </div>
        <div className="sponsored-registry-text">
          <h3>{headlineText}</h3>
          <p>{subHeadingText}</p>
        </div>

        <img src={heroImgUrl} className="sponsored-registry-banner" />

        { viewComponent }
      </div>
    );
  }

  getStateFromStore() {
    return store.getState().sponsoredregistry;
  }

  subscribeToStateChangesIfNeeded() {
    if (this.subscribedToStateChanges) {
      return;
    }
    this.handleStateChange = this.handleStateChange.bind(this);
    store.subscribe(this.handleStateChange);
    this.subscribedToStateChanges = true;
  }

  isMounted() {
    return this.mounted;
  }

  handleStateChange() {
    // This gets called whenever the state in the store changes, not just the
    // sponsored registry stuff, but it's what I could get to work... Comparing
    // current state to what was last rendered before calling setState() at least.
    // TODO figure out the connect(mapStateToProps)(SponsoredRegistry) thing to
    // make it work that way.
    if (!this.isMounted()) {
      return;   // not mounted, nothing to do
    }

    const newState = this.getStateFromStore();
    if (newState === this.state) {
      return;
    }

    this.setState(newState);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

};

function shouldShowSponsoredRegistry() {
  return window.has_sponsored_registry;
}


const SponsoredRegistrySelect = React.createClass({
  getInitialState: function() {
    return {
      selected: "",
      quantity: "",
      maxQty: 0,
      name: "",
      placeholder: "Type what you will bring here."
    }
  },
  render: function() {
    const { selected, quantity } = this.state;
    const { items, my_selections, allow_other_items } = this.props.sponsoredRegistry;
    const hasRsvpd = utils.hasRsvpd();
    let qtyItemsRemaining = 0;
    const itemNodes = items.map((option, i) => {
      const { id, name } = option;
      const key = `sponsoredregistry-option-${ i }`;
      const remaining = option.remaining;
      if (remaining > 0) {
        qtyItemsRemaining++;
        return (
          <option value={ id } key={ key }>{ name }</option>
        )
      }
    });
    const qtyNodes = [];
    const itemIndex = items.map(function(item) {
      return item.id;
    }).indexOf(selected);
    const itemInMySelectionsIndex = my_selections.map(function(item) {
      return item.id;
    }).indexOf(selected);
    const remaining = items[itemIndex] ? items[itemIndex].remaining : 0;
    for (let i = 0; i < remaining; i++) {
      const alreadyBringingItem = itemInMySelectionsIndex > -1;
      const moreWord = alreadyBringingItem ? "more" : "";
      const num = i + 1;
      let val = num;
      if (alreadyBringingItem) {
        val += my_selections[itemInMySelectionsIndex].quantity;
      }
      const key = `sponsoredregistry-qty-${i}`;
      qtyNodes.push(<option value={val} key={key}>{num} {moreWord}</option>);
    }
    const listComplete = qtyItemsRemaining == 0;
    return (
      <div className="sponsored-registry-selector-container">
        { !hasRsvpd &&
          <RsvpToPerformActionLink action="contribute" />
        }
        <div className="sponsored-registry-selector select">
          <SponsoredRegistryGuestItemTable items={items}/>
          <UserSelections mySelections={my_selections} />
          { listComplete && !allow_other_items  &&
            <div className="list-complete">Looks like everything is taken care of!</div>
          }
          { hasRsvpd && (!listComplete || allow_other_items ) &&
            <form onSubmit={ this.handleSubmit }>
              <div>
                <select className="item" onChange={ this.handleSelectChange } value={selected} required>
                  <option value="">Select an Item to Bring</option>
                  { itemNodes }
                  { allow_other_items &&
                    <option value="other" key="sponsoredregistry-option-other">Other</option>
                  }
                </select>
                <select className="quantity" onChange={this.handleQuantityChange} value={quantity} required>
                  <option value="">Qty</option>
                  { qtyNodes }
                </select>
              </div>
              <button className="button-primary">{window.sponsored_registry_data.guest_contribute_cta_text}</button>
            </form>
          }
          {!hasRsvpd &&
            <div style={{textAlign: 'center'}}>
              <RsvpToPerformActionButton action="contribute" />
            </div>
          }
        </div>
      </div>
    );
  },
  handleSelectChange: function(e) {
    const itemId = e.target.value;
    const items = this.props.sponsoredRegistry.items;
    const itemIndex = items.map(function(item) {
      return item.id;
    }).indexOf(itemId);
    const remaining = items[itemIndex] ? items[itemIndex].remaining : 0;
    this.setState({
      selected: itemId,
      maxQty: remaining
    });
  },
  handleItemChange: function(e) {
    this.setState({
      name: e.target.value
    })
  },
  handleCancelClick: function () {
    this.setState({
      selected: "",
      quantity: "",
      name: "",
      maxQty: 0
    })
  },
  handleQuantityChange: function(e) {
    const qty = e.target.value;
    this.setState({quantity: qty});
  },
  handleSubmit: function(e) {
    e.preventDefault();
    const { selected, quantity, name } = this.state;
    if (!selected || quantity < 1) {
      return false;
    }
    actions.selectItem(selected, quantity);
    this.setState({
      selected: "",
      quantity: "",
      maxQty: 0,
      name: ""
    });

    const posUrl = window.sponsored_registry_data.pos_url;
    window.open(posUrl, '_blank');

    window.dataLayer.push({'event': 'bringitem'});    // TODO what's this for?
  }
});


function SponsoredRegistryRow(props) {
  const { placeholder, autofocus } = props.item;
  const required = props.index === 0 || props.item.name.length || props.item.quantity.length;
  return (
    <tr>
      <td>
        <input type="text"
          value={ props.item.name }
          maxLength="140"
          placeholder={ placeholder }
          autoFocus={ autofocus }
          required={ required }
          onChange={ props.handleItemChange }
        />
      </td>
      <td>
        <input
          type="number"
          value={ props.item.quantity }
          min="1"
          max="999"
          placeholder="Qty"
          required={ required }
          onChange={ props.handleQtyChange }
          onKeyDown={ props.handleQtyKeyDown }
        />
        <a onClick={ props.handleRemoveClick } tabIndex="-1">
          <i className="icon-cancel"></i>
        </a>
      </td>
    </tr>
  );
}


const UserSelections = React.createClass({
  render: function(e) {
    const { mySelections } = this.props;
    const selectionNodes = mySelections.map((selection, i) => {
      const { id, quantity, name } = selection;
      const key = `sponsoredregistry-selection-${i}`;
      return (
        <p key={key}>
          You're bringing {quantity} {name}&nbsp;
          <small>
            <a href="#" onClick={this.handleRemoveSelectionClick.bind(this, id)}>
              Remove
            </a>
          </small>
        </p>
      )
    });
    return (
      <div className="youre-bringing">
        {selectionNodes}
      </div>
    );
  },
  handleRemoveSelectionClick: function(id, e) {
    e.preventDefault();
    actions.removeSelection(id);
  }
});

const SponsoredRegistryGuestItemTable = React.createClass({
  render: function () {
    let itemNodes = null;
    if (this.props.items) {
      itemNodes = this.props.items.map((item, i) => {
        if (item.id) {
          const key = `sponsoredregistry-view-item-${i}`;
          return (
            <SponsoredRegistryGuestItemRow item={item} i={i} key={key} />
          )
        }
      });
    }
    return (
      <table>
        <thead>
          <tr>
            <th className="item">Item</th>
            <th className="who">Who</th>
            <th className="needed">Still Needed</th>
          </tr>
        </thead>
        <tbody>
          {itemNodes}
        </tbody>
      </table>
    );
  }
});

const SponsoredRegistryGuestItemRow = React.createClass({
  render: function () {
    const { name, quantity, remaining, selections, id } = this.props.item;
    const selectionNodes = selections.map((selection, i) => {
      const { quantity, user } = selection;
      const { first_name, last_name } = user;
      const key = `sponsoredregistry-who-${i}`;
      return (
        <div key={key}>
          {first_name} {last_name} ({quantity})
        </div>
      );
    });
    const who = selectionNodes.length ? selectionNodes : "No one";
    return (
      <tr>
        <td className="item">{name}</td>
        <td className="who">{who}</td>
        <td className="needed">{remaining > 0 ? remaining : 0}</td>
      </tr>
    );
  }
});


export default SponsoredRegistry;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/sponsored-registry/components.es6